<div nz-row nzJustify="end">
  <div nz-col nzSpan="8" class="select">
    <nz-select class="search" [(ngModel)]="searchField">
      <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
    </nz-select>
  </div>
  <div nz-col nzSpan="16">
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input type="text" nz-input [placeholder]="placeholderText" [(ngModel)]="searchValue" (keyup.enter)="search()"/>
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <span (click)="search()" nz-icon nzType="search"></span>
      <span *ngIf="searchValue" (click)="resetSearchField()" nz-icon nzType="delete" nzTheme="twotone" nzTwotoneColor="#ff0000"></span>
    </ng-template>
  </div>
</div>
